function startBlink(setTitle, unsetTitle) {
	if (document.title.includes(setTitle)) {
		document.title = unsetTitle;
	} else {
		document.title = setTitle;
	}
}

function wait(time) {
	return new Promise(succ => {
		setTimeout(succ, time);
	});
}

/**
 * 闪烁标题
 * @param setTitle 文字1
 * @param unsetTitle 文字2
 * @param defaultTitle 结束后的文字
 * @returns {Promise<void>}
 */
export async function blink(setTitle, unsetTitle, defaultTitle) {
	while (!document.hasFocus()) {
		startBlink(setTitle, unsetTitle);
		await wait(1000);
	}
	document.title = defaultTitle;
}

/**
 * 检查通知状态
 * @returns {boolean|undefined} true 已授权； false 已拒绝；undefined 可以申请权限
 */
export function checkNotificationStatus() {
	if (!("Notification" in window)) {
		return false;
	}
	switch (Notification.permission) {
		case "granted":
			return true;
		case "denied":
			return false;
		case "default":
			return undefined;
	}
}

/**
 * 显示通知状态
 * @param msg 消息
 */
export function showNotification(msg) {
	if (checkNotificationStatus()) {
		new Notification(msg);
	}
}

/**
 * 请求权限
 */
export function requestNotifyPermission() {
	Notification.requestPermission();
}